export default __webpack_public_path__ + "static/media/kite.bdbcb8c1.ogg";